<script lang="ts">
export default {
    name: 'ProductListItemInfoElement',
};
</script>

<script setup lang="ts">
defineProps<{
    data: {
        value: unknown;
        class?: unknown;
        label?: string;
        icon?: {
            name?: string;
            class?: string;
        };
    };
}>();
</script>

<template>
    <div
        class="inline-flex items-center gap-x-1"
        :class="data.class"
    >
        <div
            v-if="data.icon"
            class="inline-flex justify-center items-center w-6"
        >
            <base-icon
                v-if="data.icon?.name"
                v-bind="data.icon"
            />
            <div
                v-else-if="data.icon?.class"
                :class="data.icon.class"
            />
        </div>

        <div
            v-if="data.label"
            v-text="`${data.label}:`"
            class="hidden text-gray-400 xl:block"
        />

        <div
            v-text="data.value"
            class="font-medium"
        />
    </div>
</template>
